import { storageLocal } from "@pureadmin/utils";
import { isUrl } from "@pureadmin/utils";
import { ElMessageBox } from "element-plus";
import bus from "vue3-eventbus";

import getChannelConfig from "@/distributions/consumer/y/channels/index";
import { initLocale } from "@/distributions/consumer/y/locales";
import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { $t } from "@/plugins/i18n";
import { router } from "@/router/index";
import { addRoutes, handleAliveRoute } from "@/router/utils";
import { useChannelStoreHook } from "@/store/modules/channel";
import { useDeploymentStoreHook } from "@/store/modules/deployment";
import { useHttpStoreHook } from "@/store/modules/http";
import { useUserStoreHook } from "@/store/modules/user";
import { updateArmsProperties } from "@/utils/log";
import { setFavicon } from "@/utils/tool";

/** 自动导入全部静态路由，无需再手动引入！匹配 src/router/modules 目录（任何嵌套级别）中具有 .js 扩展名的所有文件，除了 remaining.js 文件
 * 如何匹配所有文件请看：https://github.com/mrmlnc/fast-glob#basic-syntax
 * 如何排除文件请看：https://cn.vitejs.dev/guide/features.html#negative-patterns
 */
const modules = import.meta.glob(
  ["./modules/**/*.js", "!./modules/**/remaining.js"],
  {
    eager: true
  }
);

/** 添加路由 */
addRoutes(modules);

/** 路由白名单 */
// const whiteList = ["/login"];

let isLoaded = false;
const init = async to => {
  if (isLoaded) {
    to.meta?.beforeEnter?.(to.query);
    return;
  }
  const query = to.query?.channel
    ? to.query
    : { channel: localStorage.getItem("sys-channel") };
  await initLocale();
  await useYChannelStoreHook().init(query);
  await useUserStoreHook().getUser();

  const { channel, getChannelDefaultLanguage } = useYChannelStoreHook();
  const locale = getChannelDefaultLanguage() || "zh";
  useUserStoreHook().changeLanguage(locale);
  hoteluxDefaultInfo(locale);
  useHttpStoreHook().setHeaders({
    "y-client": "y-platform"
  });
  if (channel) {
    useHttpStoreHook().setHeaders({
      "y-platform-channel": channel
    });
    setFavicon();
    isLoaded = true;
  }
  updateArmsProperties();
};

const hoteluxDefaultInfo = locale => {
  //线上hotelux,判断未登录进入首页默认语言en,渠道走hotelux
  const href = window.location.href;
  let HLDefault = "";
  const locallang = storageLocal().getItem("y-locale");
  if (locale === "zh") {
    localStorage.removeItem("y-locale");
  }
  if (href.includes("hotel.hotelux.com")) {
    if (href.includes("hoteluxjp")) {
      HLDefault = getChannelConfig("hoteluxjp");
    } else {
      HLDefault = getChannelConfig("hotelux");
    }
    useUserStoreHook().changeLanguage(
      locallang || HLDefault.configs?.defaultLanguage
    );
  }
  // if (href.includes("hotelux")) {
  //   HLDefault = getChannelConfig("hotelux");
  //   useUserStoreHook().changeLanguage(HLDefault.configs?.defaultLanguage);
  // }
  // if (href.includes("hoteluxjp")) {
  //   HLDefault = getChannelConfig("hoteluxjp");
  //   useUserStoreHook().changeLanguage(HLDefault.configs?.defaultLanguage);
  // }
};

router.beforeEach(async (to, _from, next) => {
  bus.emit("togglePageLoading", true);
  await init(to);
  if (to.meta?.keepAlive) {
    handleAliveRoute(to, "add");
    // 页面整体刷新和点击标签页刷新
    if (_from.name === undefined || _from.name === "Redirect") {
      handleAliveRoute(to);
    }
  }
  const userStore = useUserStoreHook();
  const deploymentStore = useDeploymentStoreHook();
  if (!deploymentStore.deploymentLoaded) {
    await deploymentStore.getToggle();
  }
  const externalLink = isUrl(to?.name);
  if (!externalLink) {
    to.matched.some(item => {
      if (!item.meta.title) return "";
      const { channel } = useChannelStoreHook();
      const Title = channel?.name;
      if (Title) document.title = `${$t(item.meta.title)} | ${Title}`;
      else document.title = $t(item.meta.title);
    });
  }
  let _user = userStore.user;
  if (!_user?._id) {
    _user = await userStore.getUser();
  }
  if (to.meta.requireLogin && !_user?._id) {
    // 特殊处理hotelux集成
    if (to.path === "/credit-card-match") {
      next({
        path: "/channel-select",
        query: { redirectTo: "/external/callback/jcb", ...to?.query }
      });
    } else {
      next({ path: "/login" });
    }
  }

  const needChangeChannelSelectPage =
    useYChannelStoreHook().isNeedChooseChannel();
  if (needChangeChannelSelectPage && to.path !== "/channel-select") {
    // if (
    //   !useYChannelStoreHook().channel ||
    //   !localStorage.getItem("sys-channel")
    // )
    if (
      useYChannelStoreHook().channel === "hotelux" ||
      useYChannelStoreHook().channel === "hoteluxjp"
    ) {
      next("/channel-select");
    } else {
      to.meta?.beforeEnter?.(to.query);
      next();
    }
    return;
  }
  to.meta?.beforeEnter?.(to.query);
  next();
});

router.afterEach(() => {
  try {
    ElMessageBox.close();
  } catch (e) {
    console.log(e);
  }
  bus.emit("togglePageLoading", false);
});

export default router;
